import { atom } from 'jotai';
import type { MasterRefResponseType } from 'types/api/masterRefResponseType';

/**
 * マスター情報定義
 */
export type MasterStateType = MasterRefResponseType & {
  initialized: boolean;
};

export const MasterState = atom<MasterStateType>({
  mPlans: null,
  initialized: false,
});
